module.exports = __webpack_public_path__ + "img/14.55e22d9c.png";